/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SubjectRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let group = this.modelFor('group');
    let groupId = group.id;
    let subjectId = params.subject_id;
    let progressionType = ProgressionType.PROGRESSION;

    return hash({
      group,
      subject: store.findRecord('goals/subject', subjectId),
      levels: store.query('milestones/level', { goalSubjectId: subjectId }),
      expectations: store.query('milestones/expectation', {
        goalSubjectId: subjectId,
      }),
      progressions: store.query('milestones/progression', {
        goalSubjectId: subjectId,
        type: progressionType,
        groupId,
        latest: true,
      }),
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);

    let milestoneSetId = model.subject.milestone_set_id;
    let milestoneSet = { label: 'Default Milestones', isDefault: true };
    if (!isEmpty(milestoneSetId)) {
      milestoneSet = this.modelFor('group/expectations').milestoneSets.find(
        (set) => set.id === milestoneSetId,
      );
    }
    this.controllerFor('group/expectations').setProperties({
      currentSubjectId: model.subject.id,
      selectedMilestoneSet: milestoneSet,
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('group/expectations').set('currentSubjectId', null);
  }
}
